// pages/+Page.tsx
import { lazy, Suspense } from "react";
import LoadingComponent from "@fableous/ui/components/layout/LoadingComponent";
import OpenRoute from "@fableous/ui/components/routes/OpenRoute";
const Pricing = lazy(() => import("@fableous/ui/containers/marketing/Pricing"));

function Page() {
    return (
        <Suspense fallback={<LoadingComponent />}>
            <OpenRoute>
                <Pricing />
            </OpenRoute>
        </Suspense>
    );
}

export { Page };
